import type { ControllerRenderProps, FieldValues } from 'react-hook-form';
import { useController, useFormContext } from 'react-hook-form';

interface IReturn {
  error: string | undefined;
  field: ControllerRenderProps<FieldValues, string>;
}

interface IProps {
  name: string;
  deps?: string | string[];
}

export const useControl = ({ name, deps }: IProps): IReturn => {
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({ control, name, rules: { deps } });

  return { error: error?.message, field };
};
